import * as React from 'react';
import PageIFrame, { PageIFrameOwnProps } from '../PageIFrame';
import { makeFrameIDForSinglePage } from '../../../helpers/pages';
import { FrameInfo } from '../../../../../../common/src/ts/types/FrameInfo';
import { UIEventListeners } from '../../../../../../common/src/ts/types/uievent';
import SheetScaler, { ScaleBehavior } from '../SheetScaler';
import { UIModeState } from '../../../reducers/uimode';
import { getGlobalFrameStore } from '../../../services/FrameStore';
import { Rectangle } from 'ark-common';
import { ZoomingParams, SheetLayout, FitStyle, ScrollBase } from '../../../utils/view';
import { defaultPageIFrameBackgrouncColor } from '../../../constants';

// FIXME: mapStateToViewTransformを使ってRefactorしたい

export interface GeneratedFixedLayoutPageProps {
  title: string;
  xhtml: string;
  panelID: string;
  width: number;
  height: number;
  scaleBehavior?: 'transform' | 'resize';
  pageAreaWidth: number;
  pageAreaHeight: number;
  uiEventListeners: UIEventListeners;
  uimode: UIModeState;
}

const GeneratedFixedLayoutPage: React.SFC<GeneratedFixedLayoutPageProps> = (
  props: GeneratedFixedLayoutPageProps,
) => {
  const { width, height, panelID, pageAreaWidth, pageAreaHeight } = props;

  const frameInfo: FrameInfo = {
    panelID,
    frameID: makeFrameIDForSinglePage(panelID),
    reference: [`ark:generated-${encodeURIComponent(panelID)}.opf`, '/6/2'],
    shouldNotifyContentSize: true,
    shouldApplyReflowableContentSettings: false,
  };

  const frameID = makeFrameIDForSinglePage(panelID);
  const frameStore = getGlobalFrameStore();
  const onScaleApply = (
    visibleRect: Rectangle,
    visualScale: number,
    tabPanelAreaRect: Rectangle,
  ) => {
    const { width, height } = tabPanelAreaRect;
    frameStore.notifyVisualProperties(
      frameID,
      visibleRect,
      visualScale,
      { width, height },
      false,
    );
  };

  // FIXME: 画面フィット、中央表示で決め打ち
  const zoomingParams: ZoomingParams = {
    layout: SheetLayout.Fixed,
    sheetWidth: width,
    sheetHeight: height,
    fitStyle: FitStyle.FitScreen,
    basePosition: ScrollBase.Center,
    enableMargin: true,
    containerWidth: pageAreaWidth,
    containerHeight: pageAreaHeight,
  };

  const pageIFrameProps: PageIFrameOwnProps = {
    frameInfo,
    type: 'xhtml',
    style: defaultPageIFrameBackgrouncColor,
    content: props.xhtml,
    pointerListeners: props.uiEventListeners,
  };
  let behavior: ScaleBehavior;

  if (props.scaleBehavior === 'resize') {
    behavior = ScaleBehavior.Resize;
  } else {
    behavior = ScaleBehavior.Transform;
    pageIFrameProps.width = width;
    pageIFrameProps.height = height;
  }

  return (
    <SheetScaler
      behavior={behavior}
      panelID={panelID}
      uiEventListeners={props.uiEventListeners}
      uimode={props.uimode}
      zoomingParams={zoomingParams}
      onScaleApply={onScaleApply}>
      <PageIFrame {...pageIFrameProps} />
    </SheetScaler>
  );
};

export default GeneratedFixedLayoutPage;
